<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="settings"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Cache Login Credentials</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">This will make logging in easier.</ion-list-header>
    <ion-list lines="none">
        <ion-item>
            <ion-label position="stacked">Email</ion-label>
            <ion-input type="text" [(ngModel)]="vm.email" data-test="email1"></ion-input>
        </ion-item>

        <ion-item>
            <ion-label position="stacked">Password</ion-label>
            <ion-input type="text" [(ngModel)]="vm.password" data-test="password"></ion-input>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="getButton" color="primary" expand="full" (click)="onGetClick()">Get</ion-button>
        <ion-button data-test="setButton" color="primary" expand="full" (click)="onSetClick()">Set</ion-button>
    </ion-toolbar>
</ion-footer>